/**
 * Anteriormente chamado de converterTimeframe
 * @param {string} tf - nomenclatura de timeframe para api
 * @returns {string} - nomenclatura equivalente para o TradingView
 */
const toTradingView = (tf) => {
  if (tf === "S15") return "15S";
  if (tf === "S30") return "30S";
  if (tf === "M1") return "1";
  if (tf === "M2") return "2";
  if (tf === "M3") return "3";
  if (tf === "M5") return "5";
  if (tf === "M6") return "6";
  if (tf === "M10") return "10";
  if (tf === "M12") return "12";
  if (tf === "M15") return "15";
  if (tf === "M30") return "30";
  if (tf === "H1") return "60";
  if (tf === "T1000") return "1T";
  if (tf === "V5000") return "1T";
  if (tf === "V10000") return "1T";
  return "M10";
};

/**
 * @param {string} resolution - timeframe retornado pelo TradingView
 * @param {object} currentTimeframe - timeframe corrente
 * @returns {string} - converte para nomenclatura da API OnTick
 */
const toOnTickApi = (resolution, currentTimeframe = null) => {
  // const { identifierOnTick } = currentTimeframe;
  if (resolution === "15S") return "S15";
  if (resolution === "30S") return "S30";
  if (resolution === "1") return "M1";
  if (resolution === "2") return "M2";
  if (resolution === "3") return "M3";
  if (resolution === "5") return "M5";
  if (resolution === "6") return "M6";
  if (resolution === "10") return "M10";
  if (resolution === "12") return "M12";
  if (resolution === "15") return "M15";
  if (resolution === "30") return "M30";
  if (resolution === "60") return "H1";
  // Não está sendo usado no momento.
  /**
  if (resolution === "1T" && identifierOnTick === "T1000") return "T1000";
  if (resolution === "1T" && identifierOnTick === "V5000") return "V5000";
  if (resolution === "1T" && identifierOnTick === "V10000") return "V10000";
   */
  return "M5";
};

export const ConvertTimeframe = {
  toTradingView,
  toOnTickApi,
};
